import connectImg from '#/assets/coonect.png';
import {Modal} from '#/atoms/modal';
import {LoginGroup, MobileLoginGroup} from '#/components/login/login-group';
import {useModalContext} from '#/contexts/modal-provider';
import {Questions} from '#/pages/landing';
import {FunctionComponent, ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {useWindowSize} from 'react-use';

export type Content = {
  Icon: ReactElement<any, any>;
  header: string;
  sub?: string;
};

export const LoginModal: FunctionComponent = () => {
  const {t} = useTranslation('translation');
  // Contexts
  const {close} = useModalContext();
  const {width} = useWindowSize();

  const renderLoginContent = () => {
    if (width < 640) {
      return <MobileLoginGroup />;
    }
    return (
      <div className='flex justify-center py-6 md:py-10'>
        <div className='w-full md:w-3/5 px-4 md:px-0'>
          <h6 className='font-bold text-xl md:text-2xl mb-4 md:mb-6'>{t('pages.landing.explanation.connectWallet')}</h6>
          <LoginGroup />
          <div className='pt-4 pb-3'>
            <Questions hideIcon />
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal title='' onClose={close} hideOnClickAway={true} className='md:rounded-3xl border-none top-[-36px]'>
      <div className='w-full max-w-[800px] mx-auto md:rounded-2xl h-[800px]'>
        <>
          <img src={connectImg} alt='connect_image' className='w-full h-auto' />
          {renderLoginContent()}
        </>
      </div>
    </Modal>
  );
};
